// extracted by mini-css-extract-plugin
export default {"screenReaderOnly":"common_screenReaderOnly__F6HXO"};